import { useState } from 'react';

import Dashboard from './DepositDashboard';
export default function DadminPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="DadminPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <div><Dashboard/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
